export default function LoadingSpinner(){
    return(
        <div className="w-16 h-16 border-t-8 border-blue-200 rounded-full animate-spin">
        </div>
    )
}